import auth from './auth';

const actions = {
  auth,
};

export default actions;
